import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckFilledCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4 16a12 12 0 1 1 24 0 12 12 0 0 1-24 0Zm18.45-5.77c.33.25.4.72.15 1.05a925.2 925.2 0 0 1-7.4 8.8l-1.34 1.57-.57-.48-.57.48-.49-.58a753.22 753.22 0 0 1-2.85-3.43.75.75 0 1 1 1.24-.83 2.54 2.54 0 0 0 .16.2 57.95 57.95 0 0 0 1.51 1.8l1 1.2.76-.9a11296.79 11296.79 0 0 0 7.33-8.7l.02-.03a.75.75 0 0 1 1.05-.15ZM13.3 21.17l-.57.48a.75.75 0 0 0 1.14 0l-.57-.48Z",
		fill: "currentColor"
	})
});
export { SvgCheckFilledCircle as ReactComponent };
